var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCrown = function SvgCrown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.8 16 18 9l-4.2 2.1L12 9l-1.8 2.1L6 9l1.2 7zM21.09 12H22M12 2.91V2m0 20v-.91m7.273-1.817-.91-.91m.91-13.636-.91.91M4.728 19.272l.91-.91m-.91-13.636.91.91M2 12h.91"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;